import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Problem } from "@/components/landing/Problem";
import { Framework } from "@/components/landing/Framework";
import { Windows } from "@/components/landing/Windows";
import { SevenDays } from "@/components/landing/SevenDays";
import { PEMath } from "@/components/landing/PEMath";
import { Proof } from "@/components/landing/Proof";
import { Investment } from "@/components/landing/Investment";
import { Faq } from "@/components/landing/Faq";
import { FinalCta } from "@/components/landing/FinalCta";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="antialiased bg-[#f7f9fa]">
      <Nav />
      <main>
        <Hero />
        <Problem />
        <Framework />
        <Windows />
        <SevenDays />
        <PEMath />
        <Proof />
        <Investment />
        <Faq />
        <FinalCta />
      </main>
    </div>
  );
}

export default App;
